import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=58de16c9&scoped=true"
import script from "./page-layout.vue?vue&type=script&lang=js"
export * from "./page-layout.vue?vue&type=script&lang=js"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=58de16c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de16c9",
  null
  
)

export default component.exports